import { render, staticRenderFns } from "./Santander.vue?vue&type=template&id=4f8b2a91&scoped=true&"
import script from "./Santander.vue?vue&type=script&lang=js&"
export * from "./Santander.vue?vue&type=script&lang=js&"
import style0 from "./Santander.vue?vue&type=style&index=0&id=4f8b2a91&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b2a91",
  null
  
)

export default component.exports